import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import DynamicZone from '../components/DynamicZone';
import TabsAccordion from '../components/tabs/TabsAccordion';
import { getContentBlocks } from '../data/data-layer';

export const Route = createFileRoute('/blocks')({
    component: RouteComponent,
})

function RouteComponent() {
    const { data } = useSuspenseQuery(getContentBlocks());
    const items = (data as any)?.data || [];

    return (<div>
        <div className="cms-dynamic">
            <div className="cms-tabs">
                <TabsAccordion elements={items.map((item: any) => ({
                    title: item.name,
                    content: <DynamicZone title={item.name} elements={item.elements} contentBlockDocumentId={item.documentId} />
                }))} />
            </div>
        </div>
    </div>)
}
